import React from "react";

import images from "@/utils/images";
import type { PatientFile } from "@/features/patient/types/PatientFile";

import { formatFileRow } from "../helpers/formatFileRow";

type FileRowProps = {
  file: PatientFile;
  onView: (fileKey: string) => void;
};

export function FileRow({ file, onView }: FileRowProps) {
  const { fileName, loadDate } = formatFileRow(file);

  return (
    <>
      {/* mobile — actual view action lives on the parent ListItem's clickHandler */}
      <div className="d-flex d-lg-none justify-content-between">
        <div className="w-75 d-flex fs-14 flex-column">
          <span className="fs-16">{loadDate}</span>
          <span>{file.file_key.substring(file.file_key.lastIndexOf("/"))}</span>
        </div>
      </div>
      {/* desktop */}
      <div className="row no-gutters d-none d-lg-flex fs-14 align-items-center justify-content-between">
        <span className="col-4">{loadDate}</span>
        <span className="col-6">{fileName}</span>
        <div className="col-2 d-flex d-flex tw:justify-center">
          <button
            className="cursor ml-5 border-0 bg-transparent p-0"
            onClick={() => onView(file.file_key)}
            type="button"
          >
            <img alt="view icon" src={images("./common/view.png")} />
          </button>
        </div>
      </div>
    </>
  );
}
